import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { boolean } from "yup";

const initialState = {
  email: "",
  firstname: "",
  lastname: "",
  organization: "",
  role: "",
  organization_id:'',
  unique_devices: boolean,
  sso_enabled:false,
  global_filter: false,
  isOnlyCloudUser: false,
  isOnlyPremAssetUser: false,
  isBothCloudAndPremAssetUser: false,
  isNewUserTrue: false
};

const LoginDetailsSlice = createSlice({
  name: "LoginDetails",
  initialState,
  reducers: {
    setUserLoginDetails: (state, action) => {
      state.email = action.payload.email;
      state.firstname = action.payload.firstname;
      state.lastname = action.payload.lastname;
      state.organization = action.payload.organization;
      state.role = action.payload.role;
      state.organization_id=action.payload.organization_id;
      state.unique_devices = action.payload.unique_devices;
      state.sso_enabled = action.payload.sso_enabled;
      state.global_filter = action.payload.global_filter;
    },

    setIsOnlyCloudUser: (state, action) => {
      state.isOnlyCloudUser = action.payload.isOnlyCloudUser;
    },
    setIsOnlyPremAssetUser: (state, action) => {
      state.isOnlyPremAssetUser = action.payload.isOnlyPremAssetUser;
    },
    setIsBothCloudAndPremAssetUser: (state, action) => {
      state.isBothCloudAndPremAssetUser = action.payload.isBothCloudAndPremAssetUser;
    },
    setIsNewUserTrue: (state, action) => {
      state.isNewUserTrue = action.payload.isNewUserTrue;
    },
    resetUserTypeFlags: (state) => {
      state.isOnlyCloudUser = false;
      state.isOnlyPremAssetUser = false;
      state.isBothCloudAndPremAssetUser = false;
      state.isNewUserTrue = false;
    }
  }
});

export const { setUserLoginDetails,setIsBothCloudAndPremAssetUser,setIsNewUserTrue,setIsOnlyCloudUser,setIsOnlyPremAssetUser,resetUserTypeFlags } = LoginDetailsSlice.actions;
export default LoginDetailsSlice.reducer;
